import { render } from "./ColetaView.vue?vue&type=template&id=2383ed22"
import script from "./ColetaView.vue?vue&type=script&lang=js"
export * from "./ColetaView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__